import { IOverviewHeroSlide } from "../OverviewHero.types";
import * as S from "../OverviewHero.styles";
import React, { useCallback, useState } from "react";
import { ProDisplayVideo } from "./ProDisplayVideo";
import { OverviewTabs } from "./OverviewTabs";

export const OverviewDisplayPro = ({
  slides,
  isInView,
}: Readonly<{ slides: Array<IOverviewHeroSlide>; isInView?: boolean }>) => {
  const [activeTab, setActiveTab] = useState(slides?.[0]);
  const [videoPlaybackTime, setVideoPlaybackTime] = useState<
    Record<number | string, number>
  >({});

  const onCanStartPlayback = (
    event: React.SyntheticEvent<HTMLVideoElement>,
  ) => {
    const totalPlaybackTime = event.currentTarget.duration;

    if (!totalPlaybackTime) {
      return;
    }

    setVideoPlaybackTime((prev) => ({
      ...prev,
      [activeTab.id]: totalPlaybackTime,
    }));
  };

  const switchToNextVideo = useCallback(() => {
    setActiveTab((prev) => {
      const nextIndex = prev.index + 1;
      const isLastIndex = nextIndex >= slides.length;
      const correctedIndex = isLastIndex ? 0 : nextIndex;

      return slides[correctedIndex];
    });
  }, [slides]);

  const updateTab = useCallback((tab: IOverviewHeroSlide) => {
    setActiveTab(tab);
  }, []);

  return (
    <S.DisplayProWrapper>
      <S.RadialGradient />

      <OverviewTabs
        slides={slides}
        activeTab={activeTab}
        videoPlaybackTime={videoPlaybackTime}
        onUpdateTab={updateTab}
        isInView={isInView}
      />

      <ProDisplayVideo
        activeTab={activeTab}
        onStartVideoPlayback={onCanStartPlayback}
        onVideoEnded={switchToNextVideo}
        isInView={isInView}
      />
    </S.DisplayProWrapper>
  );
};
